export const CONSENT_STATUS = {
  loading: 'loading',
  ready: 'ready',
  sending: 'sending',
  noSelection: 'noSelection',
  expired: 'expired',
  alreadyDone: 'alreadyDone',
  failed: 'failed',
};

export const CONSENT_CONFIRMATION_STATUS = {
  confirmed: 'Confirmed',
  expired: 'Expired',
  alreadyDone: 'AlreadyDone',
};

export const SUPPORT_EMAIL = 'atendimento@portergroup.com.br';

export const COMPACT_WINDOW_MEDIA =
  'screen and (max-height: 640px) and (min-width: 768px)';

export const WELCOME_ERROR = {
  default: 'default',
};

export const SYNC_STATUS = {
  checking: 'checking',
  pending: 'pending',
  ready: 'ready',
  failed: 'failed',
  untracked: 'untracked',
};

export const SYNC_API_STATUS = {
  ready: 'Ready',
  pending: 'Pending',
  failed: 'Failed',
  expired: 'Expired',
};

export const SYNC_POLL_INTERVAL_MS = 5000;

export const SYNC_MESSAGE_INTERVAL_MS = 4000;

export const SYNC_SLOW_AFTER_MS = 45000;

export const SYNC_PROGRESS_LIMIT = 90;

export const SYNC_DONE_DELAY_MS = 1000;

export default {
  CONSENT_STATUS,
  CONSENT_CONFIRMATION_STATUS,
  SUPPORT_EMAIL,
  COMPACT_WINDOW_MEDIA,
  WELCOME_ERROR,
  SYNC_STATUS,
  SYNC_API_STATUS,
  SYNC_POLL_INTERVAL_MS,
  SYNC_MESSAGE_INTERVAL_MS,
  SYNC_SLOW_AFTER_MS,
  SYNC_PROGRESS_LIMIT,
  SYNC_DONE_DELAY_MS,
};
